[
  {
    "id": "GET-B7P-L5-001",
    "module": "Getalbegrip",
    "difficulty": 202,
    "question": "Vul de verhoudingstabel aan. Voor 4 pannenkoeken heb je 250 ml melk nodig. Hoeveel ml melk heb je nodig voor 10 pannenkoeken?",
    "options": [
      "625 ml"
    ],
    "correctAnswer": 0,
    "questionType": "ratio_table",
    "interactiveConfig": {
      "headers": ["Pannenkoeken", "Melk (ml)"],
      "rows": [["4", "250"], ["10", "625"]],
      "hiddenCells": [{ "row": 1, "col": 1 }]
    },
    "skill": "verhoudingen",
    "subSkill": "verhoudingen",
    "familyId": "GET-VERHOUDING",
    "explanation": "10 pannenkoeken is 2,5 keer zoveel als 4 (want 10 : 4 = 2,5). Je hebt dus ook 2,5 keer zoveel melk nodig: 250 $\\times$ 2,5 = 625 ml.",
    "distractorExplanations": {
      "0": "Kijk goed naar de verhouding: 10 is 2,5 keer zoveel als 4. Dus de melk moet ook 2,5 keer zoveel zijn."
    }
  },
  {
    "id": "GET-B7P-L5-002",
    "module": "Getalbegrip",
    "difficulty": 202,
    "question": "In een siroopmengsel is de verhouding siroop : water = 1 : 5. Het totale mengsel is 600 ml. Vul de tabel aan: hoeveel ml siroop zit erin?",
    "options": [
      "100 ml"
    ],
    "correctAnswer": 0,
    "questionType": "ratio_table",
    "interactiveConfig": {
      "headers": ["", "Siroop", "Water", "Totaal"],
      "rows": [["Delen", "1", "5", "6"], ["Hoeveelheid (ml)", "100", "500", "600"]],
      "hiddenCells": [{ "row": 1, "col": 1 }]
    },
    "skill": "verhoudingen",
    "subSkill": "verhoudingen",
    "familyId": "GET-VERHOUDING",
    "explanation": "De verhouding 1 : 5 betekent dat er in totaal 1 + 5 = 6 delen zijn. 600 ml : 6 = 100 ml per deel. Siroop is 1 deel, dus 100 ml.",
    "distractorExplanations": {
      "0": "Tel eerst het totaal aantal delen: 1 + 5 = 6. Deel dan 600 door 6 om de waarde van 1 deel te vinden."
    }
  },
  {
    "id": "GET-B7P-L5-003",
    "module": "Getalbegrip",
    "difficulty": 202,
    "question": "Bereken: 75% van 240 =",
    "options": [
      "160",
      "170",
      "180",
      "200"
    ],
    "correctAnswer": 2,
    "questionType": "multiple_choice",
    "skill": "procenten",
    "subSkill": "procenten",
    "familyId": "GET-PROC-BEREKENEN",
    "explanation": "75% is driekwart. 240 : 4 = 60. Dat keer 3 = 180. Of: 50% = 120, 25% = 60, samen 180.",
    "distractorExplanations": {
      "0": "Dit is twee derde van 240, niet driekwart.",
      "1": "Je maakte een rekenfout bij het vermenigvuldigen.",
      "3": "Dit is meer dan 75%. 200 van 240 is ruim 83%."
    }
  },
  {
    "id": "GET-B7P-L5-004",
    "module": "Getalbegrip",
    "difficulty": 202,
    "question": "In een klas is de verhouding jongens : meisjes = 3 : 5. Er zitten 24 leerlingen in de klas. Vul de tabel aan: hoeveel meisjes zijn er?",
    "options": [
      "15"
    ],
    "correctAnswer": 0,
    "questionType": "ratio_table",
    "interactiveConfig": {
      "headers": ["", "Jongens", "Meisjes", "Totaal"],
      "rows": [["Delen", "3", "5", "8"], ["Aantal", "9", "15", "24"]],
      "hiddenCells": [{ "row": 1, "col": 2 }]
    },
    "skill": "verhoudingen",
    "subSkill": "verhoudingen",
    "familyId": "GET-VERHOUDING",
    "explanation": "Samen zijn er 3 + 5 = 8 delen. Eén deel is 24 : 8 = 3 leerlingen. De meisjes zijn 5 delen, dus 5 $\\times$ 3 = 15 meisjes.",
    "distractorExplanations": {
      "0": "Bereken eerst hoeveel 1 deel is (24 : 8 = 3). Vermenigvuldig dan met het aantal delen voor meisjes (5)."
    }
  },
  {
    "id": "GET-B7P-L5-005",
    "module": "Getalbegrip",
    "difficulty": 202,
    "question": "Op een kaart is de schaal 1 : 25.000. Een afstand van 8 cm op de kaart is in werkelijkheid ...",
    "options": [
      "2 km",
      "200 m",
      "4 km",
      "20 km"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "verhoudingen",
    "subSkill": "verhoudingen",
    "familyId": "GET-SCHAAL",
    "explanation": "1 cm op de kaart is 25.000 cm in het echt. Dat is 250 meter. 8 cm op de kaart is 8 $\\times$ 250 meter = 2.000 meter = 2 km.",
    "distractorExplanations": {
      "1": "Je bent vergeten om te rekenen van meters naar kilometers.",
      "2": "Je dacht dat 1 cm gelijk was aan 0,5 km.",
      "3": "Je maakte een fout met de factor 10 bij het omzetten van cm naar km."
    }
  },
  {
    "id": "GET-B7P-L5-006",
    "module": "Getalbegrip",
    "difficulty": 202,
    "question": "Bereken: 35% van 400 =",
    "options": [
      "120",
      "130",
      "140",
      "150"
    ],
    "correctAnswer": 2,
    "questionType": "multiple_choice",
    "skill": "procenten",
    "subSkill": "procenten",
    "familyId": "GET-PROC-BEREKENEN",
    "explanation": "10% van 400 is 40. 30% is 3 $\\times$ 40 = 120. 5% is de helft van 10%, dus 20. Samen: 120 + 20 = 140.",
    "distractorExplanations": {
      "0": "Dit is 30% van 400. Je mist nog de 5%.",
      "1": "Je maakte een rekenfout bij het optellen van 30% en 5%.",
      "3": "Dit is 37,5% van 400, niet 35%."
    }
  },
  {
    "id": "GET-B7P-L5-007",
    "module": "Getalbegrip",
    "difficulty": 202,
    "question": "In een verfmengsel is de verhouding rood : blauw = 2 : 3. Het totale mengsel is 750 ml. Hoeveel ml rode verf zit erin?",
    "options": [
      "300 ml",
      "250 ml",
      "450 ml",
      "500 ml"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "verhoudingen",
    "subSkill": "verhoudingen",
    "familyId": "GET-VERHOUDING",
    "explanation": "Samen zijn er 2 + 3 = 5 delen. Eén deel is 750 : 5 = 150 ml. Rood is 2 delen, dus 2 $\\times$ 150 = 300 ml.",
    "distractorExplanations": {
      "1": "Dit is de inhoud van slechts één deel.",
      "2": "Dit is de hoeveelheid blauwe verf (3 delen).",
      "3": "Je dacht dat rood 2/3 van het mengsel was, maar het is 2/5."
    }
  },
  {
    "id": "GET-B7P-L5-008",
    "module": "Getalbegrip",
    "difficulty": 202,
    "question": "Je zet € 600,- op de bank met 3% rente per jaar. Hoeveel geld heb je na precies één jaar op je rekening staan?",
    "options": [
      "€ 618,-",
      "€ 603,-",
      "€ 630,-",
      "€ 620,-"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "procenten",
    "subSkill": "procenten",
    "familyId": "GET-PROC-RENTE",
    "explanation": "1% van 600 is € 6,-. 3% is dus 3 $\\times$ 6 = 18 euro rente. In totaal heb je dan 600 + 18 = 618 euro.",
    "distractorExplanations": {
      "1": "Je telde er slechts 3 euro bij op in plaats van 3%.",
      "2": "Je rekende met 5% rente (€ 30,-).",
      "3": "Je rondde de rente af op een rond bedrag van € 20,-."
    }
  },
  {
    "id": "GET-B7P-L5-009",
    "module": "Getalbegrip",
    "difficulty": 202,
    "question": "Voor 5 personen heb je 750 g pasta nodig. Vul de verhoudingstabel aan: hoeveel gram pasta heb je nodig voor 8 personen?",
    "options": [
      "1200 g"
    ],
    "correctAnswer": 0,
    "questionType": "ratio_table",
    "interactiveConfig": {
      "headers": ["Personen", "Pasta (g)"],
      "rows": [["5", "750"], ["1", "150"], ["8", "1200"]],
      "hiddenCells": [{ "row": 2, "col": 1 }]
    },
    "skill": "verhoudingen",
    "subSkill": "verhoudingen",
    "familyId": "GET-VERHOUDING",
    "explanation": "Bereken eerst wat 1 persoon nodig heeft: 750 : 5 = 150 g. Voor 8 personen is dat 8 $\\times$ 150 = 1.200 g.",
    "distractorExplanations": {
      "0": "Bereken eerst de hoeveelheid per persoon (750 : 5 = 150 g) en vermenigvuldig dan met 8."
    }
  },
  {
    "id": "GET-B7P-L5-010",
    "module": "Getalbegrip",
    "difficulty": 202,
    "question": "Bereken: $\\frac{2}{3}$ van 90 =",
    "options": [
      "60",
      "45",
      "30",
      "75"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "breuken",
    "subSkill": "breuken_deel_van",
    "familyId": "GET-BREUK-DEEL",
    "explanation": "Deel 90 eerst door 3 om $\\frac{1}{3}$ te weten (90 : 3 = 30). Doe dat keer 2 voor $\\frac{2}{3}$: 2 $\\times$ 30 = 60.",
    "distractorExplanations": {
      "1": "Dit is de helft (1/2), niet twee-derde.",
      "2": "Dit is $\\frac{1}{3}$ deel, je vergat te vermenigvuldigen met 2.",
      "3": "Dit is 5/6 deel, wat veel meer is dan 2/3."
    }
  },
  {
    "id": "GET-B7P-L5-011",
    "module": "Getalbegrip",
    "difficulty": 202,
    "question": "De schaal van een bouwtekening is 1 : 100. Een muur van 3,5 cm op de tekening is in werkelijkheid ...",
    "options": [
      "3,5 m",
      "35 m",
      "0,35 m",
      "1,5 m"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "verhoudingen",
    "subSkill": "verhoudingen",
    "familyId": "GET-SCHAAL",
    "explanation": "Schaal 1 : 100 betekent 1 cm = 100 cm. Omdat 100 cm gelijk is aan 1 meter, is 1 cm op tekening 1 meter in het echt. 3,5 cm is dus 3,5 meter.",
    "distractorExplanations": {
      "1": "Je schoof de komma te ver weg bij het omrekenen van cm naar m.",
      "2": "Je deelde door 10 in plaats van te vermenigvuldigen met 100.",
      "3": "Je maakte een fout in de verhouding of schaal."
    }
  },
  {
    "id": "GET-B7P-L5-012",
    "module": "Getalbegrip",
    "difficulty": 202,
    "question": "Een fietser rijdt met een constante snelheid van 18 km per uur. Hoeveel kilometer legt hij af in 1,5 uur?",
    "options": [
      "27 km",
      "24 km",
      "30 km",
      "21 km"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "verhoudingen",
    "subSkill": "verhoudingen",
    "familyId": "GET-SNELHEID",
    "explanation": "In 1 uur rijdt hij 18 km. In een half uur (0,5 uur) rijdt hij de helft: 9 km. Samen is dat 18 + 9 = 27 km.",
    "distractorExplanations": {
      "1": "Je dacht dat een half uur 6 km was in plaats van 9 km.",
      "2": "Je rekende bijna met 2 uur tijd.",
      "3": "Je maakte een fout bij het halveren van 18."
    }
  },
  {
    "id": "GET-B7P-L5-013",
    "module": "Getalbegrip",
    "difficulty": 202,
    "question": "Een winkel verkoopt 24 boeken voor € 9,- per stuk. Hoeveel kosten 24 boeken in totaal?",
    "options": [
      "€ 196,-",
      "€ 206,-",
      "€ 216,-",
      "€ 226,-"
    ],
    "correctAnswer": 2,
    "questionType": "multiple_choice",
    "skill": "basisrekenen",
    "subSkill": "vermenigvuldigen",
    "familyId": "GET-KEER-CONTEXT",
    "explanation": "24 $\\times$ 9 = 216. Je kunt dit uitrekenen als 24 $\\times$ 10 = 240, min 24 = 216.",
    "distractorExplanations": {
      "0": "Je maakte een rekenfout. 24 $\\times$ 9 is niet 196.",
      "1": "Je maakte een kleine rekenfout bij het aftrekken.",
      "3": "Je telde er 10 te veel bij op."
    }
  },
  {
    "id": "GET-B7P-L5-014",
    "module": "Getalbegrip",
    "difficulty": 202,
    "question": "Bereken: 20% van 350 =",
    "options": [
      "60",
      "65",
      "70",
      "75"
    ],
    "correctAnswer": 2,
    "questionType": "multiple_choice",
    "skill": "procenten",
    "subSkill": "procenten",
    "familyId": "GET-PROC-BEREKENEN",
    "explanation": "10% van 350 is 35. 20% is het dubbele: 2 $\\times$ 35 = 70.",
    "distractorExplanations": {
      "0": "Je rekende waarschijnlijk met 17% of maakte een vermenigvuldigingsfout.",
      "1": "Je maakte een kleine rekenfout. 2 $\\times$ 35 = 70, niet 65.",
      "3": "Dit is iets meer dan 20%. Controleer: 75 van 350 is ruim 21%."
    }
  },
  {
    "id": "GET-B7P-L5-015",
    "module": "Getalbegrip",
    "difficulty": 202,
    "question": "In een doos zitten rode en blauwe pennen in de verhouding 3 : 7. Er zitten 40 pennen in de doos. Hoeveel blauwe pennen zijn er?",
    "options": [
      "21",
      "24",
      "28",
      "30"
    ],
    "correctAnswer": 2,
    "questionType": "multiple_choice",
    "skill": "verhoudingen",
    "subSkill": "verhoudingen",
    "familyId": "GET-VERHOUDING",
    "explanation": "Samen zijn er 3 + 7 = 10 delen. Eén deel is 40 : 10 = 4 pennen. Blauw is 7 delen, dus 7 $\\times$ 4 = 28 blauwe pennen.",
    "distractorExplanations": {
      "0": "Dit is het aantal als er maar 30 pennen in de doos zaten.",
      "1": "Je rekende met 6 delen blauw in plaats van 7.",
      "3": "Je rekende met 3/4 van 40 in plaats van 7/10."
    }
  }
]